import { createSlice } from "@reduxjs/toolkit";
import { getInternalFundTransferReport } from "./actions/internalFundTransferReport";

const initialState = {
  internalFundTransferReport: null,
  total: 0,
  loading: false,
  pageState: { page: 1, pageSize: 50 },
};

export const internalFundTransferReportSlice = createSlice({
  name: "internalFundTransferReport",
  initialState,
  reducers: {
    setInternalFundTransferPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.pageState = {
          ...state.pageState,
          page,
        };
      }
      if (pageSize) {
        state.pageState = {
          ...state.pageState,
          pageSize,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInternalFundTransferReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInternalFundTransferReport.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.internalFundTransferReport = data;
        if (user) {
          sessionStorage.setItem("intFundTransUsers", JSON.stringify(user));
        }
        state.total = count;
      })
      .addCase(getInternalFundTransferReport.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setInternalFundTransferPage } =
  internalFundTransferReportSlice.actions;

export default internalFundTransferReportSlice.reducer;
